import React, { useState, useEffect } from "react";
import { Chart } from "primereact/chart";

export default function DivisionWiseCategory({ data }: any) {
    const [chartData, setChartData] = useState({});
    const [chartOptions, setChartOptions] = useState({});

    useEffect(() => {
        if (!data) return;

        const result = Object.entries(data).map(([key, value]) => ({
            name: key
                .replace(/_category_count$/, "")
                .replace(/_/g, " ")
                .replace(/\b\w/g, (c) => c.toUpperCase()),
            count: Number(value),
        }));

        const documentStyle = getComputedStyle(document.documentElement);

        const bgColors = [
            documentStyle.getPropertyValue("--blue-500"),
            documentStyle.getPropertyValue("--yellow-500"),
            documentStyle.getPropertyValue("--green-500"),
            documentStyle.getPropertyValue("--pink-500"),
            documentStyle.getPropertyValue("--purple-500"),
            documentStyle.getPropertyValue("--cyan-500"),
            documentStyle.getPropertyValue("--orange-500"),
        ];

        const hoverColors = [
            documentStyle.getPropertyValue("--blue-400"),
            documentStyle.getPropertyValue("--yellow-400"),
            documentStyle.getPropertyValue("--green-400"),
            documentStyle.getPropertyValue("--pink-400"),
            documentStyle.getPropertyValue("--purple-400"),
            documentStyle.getPropertyValue("--cyan-400"),
            documentStyle.getPropertyValue("--orange-400"),
        ];

        const chartDataObj = {
            labels: result.map((item) => item.name),
            datasets: [
                {
                    label: "Division Wise Category",
                    data: result.map((item) => item.count),
                    backgroundColor: result.map((_, index) => bgColors[index % bgColors.length]),
                    hoverBackgroundColor: result.map(
                        (_, index) => hoverColors[index % hoverColors.length]
                    ),
                    borderWidth: 1,
                },
            ],
        };

        const options = {
            cutout: "30%",
            maintainAspectRatio: false,
            plugins: {
                legend: {
                    position: "bottom",
                },
                title: {
                    display: true,
                    text: "Division Wise Category",
                },
            },
        };

        setChartData(chartDataObj);
        setChartOptions(options);
    }, [data]);

    return (
        <div className="card">
            <div style={{ height: "253px" }}>
                <Chart
                    type="doughnut"
                    data={chartData}
                    options={chartOptions}
                    className="w-full h-full"
                />
            </div>
        </div>
    );
}